import React, { ForwardRefRenderFunction, useImperativeHandle, forwardRef, useState } from "react";

import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { FiInfo } from "react-icons/fi";

import ConfirmationModal from "../../../../../../../../../components/Dialogs/ConfirmationModal";
import { Color } from "../../../../../../../../../components/Form/Button";

export const UnloadStorageBoxConfirmationStyled = styled("p")(() => ({
  fontFamily: "Inter",
  fontWeight: 400,
  fontSize: "1rem",
  lineHeight: "1.5rem",
  "& span": {
    fontWeight: 700,
  },
}));

interface UnloadStorageBoxConfirmationProps {
  isLoading: boolean;
  onSubmit: (storageBoxId: number) => void;
}

export interface UnloadStorageBoxConfirmationHandler {
  open: (data: string, id: number) => void;
  close: () => void;
}

const UnloadStorageBoxConfirmation: ForwardRefRenderFunction<
  UnloadStorageBoxConfirmationHandler,
  UnloadStorageBoxConfirmationProps
> = (props, ref) => {
  const { t: translate } = useTranslation();
  const { isLoading = false, onSubmit } = props;

  const [open, setOpen] = useState<boolean>(false);
  const [object, setObject] = useState<string>("");
  const [id, setId] = useState<number>();

  const onOpen = (data: string, sbId: number) => {
    setOpen(true);
    setObject(data);
    setId(sbId);
  };

  const onClose = () => {
    setOpen(false);
    setObject("");
  };

  useImperativeHandle(ref, () => ({
    open: onOpen,
    close: onClose,
  }));

  return (
    <ConfirmationModal
      open={open}
      closeModal={() => setOpen(false)}
      customColorSave={Color.ERROR}
      loading={isLoading}
      textSubmit={translate("confirm")}
      type={"error"}
      title={translate("removeStorageBox")}
      submit={() => onSubmit(Number(id))}
      width="32.5rem !important"
      leftIconTitle={<FiInfo color="#12B76A" />}
      data-cy="confirmation-modal"
    >
      <div>
        <UnloadStorageBoxConfirmationStyled>
          {translate("the")} <span>{object}</span>{" "}
          {translate("willBeRemoveAllOfTheItemsWillUnloadFromIt")}{" "}
          {translate("areYouSureYouWantToContinue")}
        </UnloadStorageBoxConfirmationStyled>
      </div>
    </ConfirmationModal>
  );
};

export default forwardRef(UnloadStorageBoxConfirmation);
